module.exports = __webpack_public_path__ + "img/film-01.5672037b.svg";